import messages from '../../../locale/messages';
import { inputTextLimit } from '../../../helpers/inputTextLimit';


const validate = values => {

  const errors = {}

  if (!values.fcmPushNotificationKey || values.fcmPushNotificationKey.toString().trim() == "") {
    errors.fcmPushNotificationKey = messages.required;
  }

  if (!values.smtpHost || values.smtpHost.toString().trim() == "") {
    errors.smtpHost = messages.required;
  } else if (values?.smtpHost?.length > inputTextLimit) {
    errors.smtpHost = messages.textAreaError;
  }

  if (!values.smtpPort || values.smtpPort.toString().trim() == "") {
    errors.smtpPort = messages.required;
  } else if (values?.smtpPort?.length > inputTextLimit) {
    errors.smtpPort = messages.textAreaError;
  }

  if (!values.smptEmail || values.smptEmail.toString().trim() == "") {
    errors.smptEmail = messages.required && messages.required;
  } else if (values?.smptEmail?.length > inputTextLimit) {
    errors.smptEmail = messages.textAreaError;
  }

  if (!values.smtpSender || values.smtpSender.toString().trim() == "") {
    errors.smtpSender = messages.required;
  } else if (values?.smtpSender?.length > inputTextLimit) {
    errors.smtpSender = messages.textAreaError;
  }

  if (!values.smtpPassWord || values.smtpPassWord.toString().trim() == "") {
    errors.smtpPassWord = messages.required;
  } else if (values?.smtpPassWord?.length > inputTextLimit) {
    errors.smtpPassWord = messages.textAreaError;
  }


  if (!values.smtpSenderEmail) {
    errors.smtpSenderEmail = messages.required && messages.required;
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,6}$/i.test(values.smtpSenderEmail)) {
    errors.smtpSenderEmail = messages.emailInvalid && messages.emailInvalid;
  } else if (values?.smtpSenderEmail?.length > inputTextLimit) {
    errors.smtpSenderEmail = messages.textAreaError;
  }

  if (!values.stripePublishableKey || values.stripePublishableKey.toString().trim() == "") {
    errors.stripePublishableKey = messages.required;
  } else if (values?.stripePublishableKey?.length > inputTextLimit) {
    errors.stripePublishableKey = messages.textAreaError;
  }

  if (!values.maxUploadSize || Number(values.maxUploadSize) < 1 || values.maxUploadSize.toString().trim() == "") {
    errors.maxUploadSize = messages.required;
  } else if (values.maxUploadSize) {
    if (isNaN(values.maxUploadSize)) {
      errors.maxUploadSize = messages.numericValue;
    }
  }

  return errors;
}

export default validate;
